import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$DELETE_FAVOURITE_ORDER/REQUESTED';
const BLOCKED = '$DELETE_FAVOURITE_ORDER/BLOCKED';
const APPROVED = '$DELETE_FAVOURITE_ORDER/APPROVED';
const SUCCEEDED = '$DELETE_FAVOURITE_ORDER/SUCCEEDED';
const FAILED = '$DELETE_FAVOURITE_ORDER/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      id: string;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, standardEmptyACC),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
